import React from 'react'
import { MdArrowOutward } from 'react-icons/md'
import { RevealLine } from './ui/Reveal'

const socials = [
  { name: 'GitHub', url: 'https://github.com/WilsonTomisin' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/oluwatomisin-wilson-992923270' },
  { name: 'Medium', url: 'https://medium.com/@tommywilson972' },
  { name: 'Linktree', url: 'https://linktr.ee/WilsonTomisin' },
]

export const Footer = () => {
  return (
    <footer className=' bg-panel text-paper px-6 md:px-10 pt-20 pb-8 overflow-hidden'>
      <div className=' max-w-7xl mx-auto'>
        <div className=' grid md:grid-cols-12 gap-10 border-b border-paper/15 pb-14'>
          <div className=' md:col-span-7'>
            <h2 className=' font-display text-5xl md:text-7xl tracking-tight leading-[0.95]'>
              <RevealLine>Let&apos;s build</RevealLine>
              <RevealLine delay={0.1}>
                <span className=' italic font-normal text-mint'>something.</span>
              </RevealLine>
            </h2>
            <a
              href='mailto:info@wilsontomisin.com'
              className=' group inline-flex items-center gap-2 mt-8 text-lg md:text-xl text-paper/80 hover:text-mint transition-colors break-all'>
              info@wilsontomisin.com
              <MdArrowOutward className=' shrink-0 transition-transform duration-300 group-hover:rotate-45' />
            </a>
          </div>
          <div className=' md:col-span-5 md:col-start-9'>
            <h3 className=' font-mono text-xs uppercase tracking-[0.2em] text-paper/40 mb-2'>Elsewhere</h3>
            <ul>
              {socials.map((s, i) => (
                <li key={i}>
                  <a
                    href={s.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    className=' group flex items-center justify-between py-3 border-t border-paper/15 text-base hover:text-mint transition-colors'>
                    {s.name}
                    <MdArrowOutward className=' text-paper/40 transition-all duration-300 group-hover:text-mint group-hover:rotate-45' />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className=' flex flex-wrap items-center justify-between gap-3 pt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/50'>
          <span>© {new Date().getFullYear()} Wilson Oluwatomisin</span>
          <span>All rights reserved</span>
        </div>

        <div className=' mt-10'>
          <h3 className=' font-display font-semibold text-[19vw] leading-[0.8] tracking-tighter text-paper/10 whitespace-nowrap'>WILSON</h3>
        </div>
      </div>
    </footer>
  )
}
